import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75d391f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sticker-popup" }
const _hoisted_2 = { class: "scrollable" }
const _hoisted_3 = { class: "sticker-list" }
const _hoisted_4 = { class: "grid grid-cols-3 md:grid-cols-4 m-0 pt-2" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "sticker" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "layout"
}
const _hoisted_9 = ["src"]

import { computed } from 'vue'
import Tabs from '../common/Tabs.vue'
import useSticker from '@/composables/room/useSticker'
import { ITab } from '@/types/interfaces/common.interface'

interface StickerEmits {
  (e: 'close'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Sticker',
  props: {
  isEnable: {
    type: Boolean,
    default: false,
  },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {


const emit = __emit

const {
  categories,
  activeCategory,
  showingSticker,
  stickerPathToShow,
  showingFullScreen,
  stickers,
  sendSticker,
} = useSticker()

const categoriesTabs = computed<ITab[]>(() =>
  categories.value.map((cat) => {
    return { label: cat, value: cat }
  }),
)
const close = () => {
  emit('close')
}
const selectSticker = async (stickerUrl: string) => {
  await sendSticker(stickerUrl)
  close()
}

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "fade-scale" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "close-button _pointer-on-hover",
            onClick: close
          }, [
            _createVNode(_component_SvgIcon, {
              class: "close-icon",
              icon: "close",
              "inherit-fill": true,
              height: "32"
            })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(Tabs, {
                modelValue: _unref(activeCategory),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(activeCategory) ? (activeCategory).value = $event : null)),
                tabs: categoriesTabs.value
              }, null, 8, ["modelValue", "tabs"]),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stickers)[_unref(activeCategory)], (sticker, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "sticker-wrapper _pointer-on-hover _prevent-text-select",
                    onClick: ($event: any) => (selectSticker(sticker.url))
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("img", {
                        src: sticker.thumbUrl,
                        alt: "",
                        loading: "lazy"
                      }, null, 8, _hoisted_7)
                    ])
                  ], 8, _hoisted_5))
                }), 128))
              ])
            ])
          ])
        ], 512), [
          [_vShow, __props.isEnable]
        ])
      ]),
      _: 1
    }),
    (_unref(showingSticker))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", {
            class: _normalizeClass(["sticker", { fullscreen: _unref(showingFullScreen) }])
          }, [
            (_unref(stickerPathToShow))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _unref(stickerPathToShow),
                  alt: ""
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})